import { render, staticRenderFns } from "./UserExtras.vue?vue&type=template&id=31e6394c&"
import script from "./UserExtras.vue?vue&type=script&lang=js&"
export * from "./UserExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QInput,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCardSection,QInput,QInnerLoading,QSpinnerGears}, component.options.components || {})
